<div class="container">
  <p>
    Although you have successfully logged in, your account does not have the correct permissions
    to access the page you requested. Please return to the <a href="/dashboard">dashboard</a>
    or select a page you have permission for from the navbar above. If you receive this error even
    from the dashboard, you are not permitted to use this portal. If you believe your permissions
    are in error, please contact an administrator.
  </p>
</div>
